import Button from '../../Button'
import { ICON_CHEVRON_DIRECTION } from '../../Icon'
import { NavArrowButton } from '../../NavArrow'

import * as styles from './ScrollSliderButtons.module.css'

function ScrollSliderButtons({
  isNextBtnVisible,
  isPrevBtnVisible,
  nextButtonClassName = styles.ScrollSliderNextButton,
  prevButtonClassName = styles.ScrollSliderPrevButton,
  onClickNextBtn,
  onClickPrevBtn,
}) {
  return (
    <>
      {isPrevBtnVisible ? (
        <div className={prevButtonClassName}>
          <NavArrowButton
            isGrey
            Component={Button.White}
            direction={ICON_CHEVRON_DIRECTION.LEFT}
            onClick={onClickPrevBtn}
          />
        </div>
      ) : null}
      {isNextBtnVisible ? (
        <div className={nextButtonClassName}>
          <NavArrowButton
            isGrey
            Component={Button.White}
            onClick={onClickNextBtn}
          />
        </div>
      ) : null}
    </>
  )
}

export default ScrollSliderButtons
